export default "__VITE_ASSET__CKvTbufZ__"